// src/hooks/useDealdenLoader.ts
import { useState, useCallback } from 'react';

interface LoaderState {
  isVisible: boolean;
  message?: string;
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
}

export const useDealdenLoader = () => {
  const [loaderState, setLoaderState] = useState<LoaderState>({
    isVisible: false,
    message: 'Loading...',
    size: 'medium',
    fullScreen: true,
  });

  const showLoader = useCallback(
    (options?: Partial<Omit<LoaderState, 'isVisible'>>) => {
      setLoaderState((prev) => ({
        ...prev,
        isVisible: true,
        ...options,
      }));
    },
    []
  );

  const hideLoader = useCallback(() => {
    setLoaderState((prev) => ({
      ...prev,
      isVisible: false,
    }));
  }, []);

  const updateLoader = useCallback(
    (options: Partial<Omit<LoaderState, 'isVisible'>>) => {
      setLoaderState((prev) => ({
        ...prev,
        ...options,
      }));
    },
    []
  );

  return {
    loaderState,
    showLoader,
    hideLoader,
    updateLoader,
    isVisible: loaderState.isVisible,
  };
};

export default useDealdenLoader;
